
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherSalesDialog extends _Ext.TransDialog<GiftVoucherSalesRow, any> {
        protected getFormKey() { return GiftVoucherSalesForm.formKey; }
        protected getIdProperty() { return GiftVoucherSalesRow.idProperty; }
        protected getLocalTextPrefix() { return GiftVoucherSalesRow.localTextPrefix; }
        protected getNameProperty() { return GiftVoucherSalesRow.nameProperty; }
        protected getService() { return GiftVoucherSalesService.baseUrl; }
        protected getDeletePermission() { return GiftVoucherSalesRow.deletePermission; }
        protected getInsertPermission() { return GiftVoucherSalesRow.insertPermission; }
        protected getUpdatePermission() { return GiftVoucherSalesRow.updatePermission; }
        public vouchertotal: number;
        public receipttotal: number;
        public Closing: boolean;
        protected form = new GiftVoucherSalesForm(this.idPrefix);
        constructor() {
            super();
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.ReceiptDetails);
            q.setTextRightAlign(this.form.TotalAmount);
            this.form.POSCustomerId.changeSelect2(e => {
                this.form.ItemDetails.CompanyId = parseInt(this.form.POSCustomerId.value);
            });
            this.form.EmployeeId.changeSelect2(e => {
                this.form.ItemDetails.EmployeeId = parseInt(this.form.EmployeeId.value);
            }); 
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });
        }
        public CalculateTotals() {
           var Items = this.form.ItemDetails.getItems();

            this.vouchertotal = 0;
            for (var i = 0; i < Items.length; i++) {
                this.vouchertotal += Items[i].Amount;

            }
            this.form.TotalAmount.value = this.vouchertotal;
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.POSCustomerId.value != "") {
                this.form.UserId.value = Q.Authorization.userDefinition.UserId.toString();
            }
        }
        onDialogClose() {
            super.onDialogClose();
            this.Closing = true;

        }
        protected validateBeforeSave() {
            super.validateBeforeSave();
            var vouchers = this.form.ItemDetails.getItems();
            var receipts = this.form.ReceiptDetails.getItems();
            this.vouchertotal = 0;
            this.receipttotal = 0;
            for (var i = 0; i < vouchers.length; i++) {
                this.vouchertotal += vouchers[i].Amount;
            }
            for (var j = 0; j < receipts.length; j++) {
                this.receipttotal += receipts[j].Amount;
            }
            if (this.receipttotal != this.vouchertotal)
                return false;
            else
                return true;
        }
    }
}